import React, { useState, useEffect, useMemo } from 'react'

import { useSelector, useDispatch } from 'react-redux';
import { setMaterialCategory, setWallMaterial, setDensity, setThickness, setThermalCoeff } from '../../../slices/WallsCharacteristics/WallsCharacteristicsSlice';
import { selectorWallsCharacteristics } from '../../../slices/WallsCharacteristics/WallsCharacteristicsSelectors';

import { CustomSelect, prepareSelectsData, prepareSelectsDataByKeyValue } from '../../UI/CustomSelect/CustomSelect'
import { Display } from '../../Display/Display'
import { Notice } from '../../Notice/Notice'
import { CustomInput } from '../../UI/CustomInput/CustomInput'

import { getObjectKeyByDepthLvl } from '../../../helpers/getObjectKeyByDepthLvl';
import { useGetJsonData } from '../../../custom-hooks/useGetJsonData';

import { termsOfUse } from '../../../data/termsOfUse';

import './WallsCharacteristics.css'


const leterToCollumnIndex = (letter) => {
  switch(letter) {
    case 'А': 
      return 4;
    case 'Б':
      return 5;
    default:
      throw new Error('unknow litter')
  }
}

export const WallsCharacteristics = () => {
  const dispatch = useDispatch();

  const [wallMaterialList, setWallMaterialList] = useState();
  const [densityList, setDensityList] = useState();
  const [vaporCoeff, setVaporCoeff] = useState();

  const materialCategory = useSelector(state => state.wallsCharacteristics.materialCategory);
  const [wallMaterial, density, thickness, thermalCoeff] = useSelector(selectorWallsCharacteristics);

  const humidity = useSelector(state => state.humidityZone.humidity)
  const humidityType = useSelector(state => state.humidityRoom.humidityType);
 
  const materialsTitlesPrepared = useGetJsonData('material-titles.json');
  const materialsTitle = prepareSelectsDataByKeyValue(materialsTitlesPrepared);


  const materialI = useGetJsonData('material1.json');
  const materialII = useGetJsonData('material2.json');
  const materialIII = useGetJsonData('material3.json');
  const materialIV = useGetJsonData('material4.json');
  const materialV = useGetJsonData('material5.json');
  const materialVI = useGetJsonData('material6.json');


  const materialsByType = useMemo(() => ({
    'I': materialI,
    'II': materialII,
    'III': materialIII,
    'IV': materialIV,
    'V': materialV,
    'VI': materialVI,
  }), [materialI, materialII, materialIII, materialIV, materialV, materialVI])
  
  useEffect(() => {
    const currentMaterial = materialsByType[materialCategory?.value];
    setWallMaterialList(currentMaterial);
  }, [materialsByType, materialCategory])

  useEffect(() => {
    const densityList = wallMaterialList ? wallMaterialList[wallMaterial?.value] : {};
    setDensityList(densityList);
  }, [wallMaterialList, wallMaterial])


  useEffect(() => {
    const wallWithCurrDensity = densityList ? densityList[density?.value] : '';
    const leter = termsOfUse[humidityType][humidity]

    // коэф теплопроводности и паропроницаемости - это 4,5 и 6 столбцы в csv  файлах материалов
    const thermalPositionIndex = leterToCollumnIndex(leter);
    const thermalCoeff = wallWithCurrDensity ? getObjectKeyByDepthLvl(wallWithCurrDensity, thermalPositionIndex) : '';
    const vaporCoeff = wallWithCurrDensity ? getObjectKeyByDepthLvl(wallWithCurrDensity, 6) : '';

    dispatch(setThermalCoeff(thermalCoeff))
    setVaporCoeff(vaporCoeff)
  }, [densityList, density, humidity, humidityType, dispatch])

  const inputHandler = (value) => {
    const valueWithoutLetter = value.replace(/\D/, '');
    dispatch(setThickness({value: valueWithoutLetter}));
  }


  return (
    <div className='walls-characteristic'>
      <div className="walls-characteristic__selects">
        <div className="walls-characteristic__select-item">
          <CustomSelect 
            options={materialsTitle} 
            onChange={(choice) => dispatch(setMaterialCategory(choice))}
            placeholder={'Категории материалов'}
            value={materialCategory || ''}
          />
        </div>
        <div className="walls-characteristic__select-item">
          <CustomSelect 
            options={prepareSelectsData(wallMaterialList)} 
            onChange={(choice) => dispatch(setWallMaterial(choice))}
            placeholder={'Материал стены'}
            value={wallMaterial || ''}

          />
        </div>

        <div className="walls-characteristic__select-group">
          <div className="walls-characteristic__group-item">
            <CustomSelect 
              options={prepareSelectsData(densityList)}
              onChange={(choice) => dispatch(setDensity(choice))}
              placeholder={'Плотность'}
              value={density || ''}
              
            />
          </div>
          <div className="walls-characteristic__group-item">
            <CustomInput 
              placeholder={'Толщина стены, мм'}
              onInput={inputHandler}
              value={thickness?.value || ''}
            />
          </div>
        </div>
      </div>
      <div className="walls-characteristic__displays">
        <div className="walls-characteristic__display-wrapper">
          <Display 
            text={'Расчётный коэффициент теплопроводности'} 
            className={'walls-characteristic__display-item'}
            displayParam={thermalCoeff}
          >
            <Notice>
              <div className="walls-characteristic__notice">
                Теплопроводность — способность более нагретого материала передавать 
                тепло менее нагретому. Чем выше этот показатель, тем больше тепловой 
                энергии способен передать или отдать материал в единицу времени.
              </div>

              {/* <div className="display__notice-wrapper--mobile">
                Теплопроводность — способность более нагретого материала передавать 
                тепло менее нагретому. Чем выше этот показатель, тем больше тепловой 
                энергии способен передать или отдать материал в единицу времени.
              </div> */}
            </Notice>
          </Display>
        </div>
        <div className="walls-characteristic__display-wrapper">
          <Display 
            text={'Расчётный коэффициент паропроницаемости'} 
            className={'walls-characteristic__display-item'}
            displayParam={vaporCoeff}
          >
            <Notice>
              <div className="walls-characteristic__notice">
                <p className="walls-characteristic__notice-paragraph">
                  Паропроницаемость — способность материала пропускать 
                  (или задерживать внутри себя) пар.
                </p>
                <p className="walls-characteristic__notice-paragraph">
                  Высокая паропроницаемость говорит о том, что материал «дышащий», 
                  он легко пропускает пар. Низкая — о паронепроницаемости.
                </p>
              </div>
            </Notice>
          </Display>
        </div>
      </div>

    </div>
  )
}
